import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import React from 'react';

import Tooltip from 'retired/Tooltip';
import { grayish } from 'utils/color-styles';

const DonationDisbursementTooltip = ({ providerName }: { providerName: string }) => (
  <Tooltip
    title={`The date is an estimate based on ${providerName}'s disbursement dates and may vary`}
  >
    <InfoOutlinedIcon
      style={{
        width: 20,
        height: 20,
        color: grayish,
      }}
    />
  </Tooltip>
);

export default DonationDisbursementTooltip;
